module.exports = __webpack_public_path__ + "static/join-us-d30b0b25e7288cc085fe65548d0b275e.mp4";